import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Custom hook for real-time user access updates from Supabase
 * Listens for changes to the users table and triggers a callback when access changes
 */
export const useRealtimeAccess = (
  userEmail: string | undefined,
  onAccessChange: () => void
) => {
  useEffect(() => {
    if (!userEmail) return;

    // Set up real-time subscription for user access changes
    const channel = supabase
      .channel('user-access-realtime')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'users',
          filter: `email=eq.${userEmail}`
        },
        (payload) => {
          console.log('Real-time user access update:', payload);
          onAccessChange();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userEmail, onAccessChange]);
};